import SjProgress from './SjProgress'

SjProgress.install = function (Vue) {
  Vue.component(SjProgress.name, SjProgress)
}

export default SjProgress



// WEBPACK FOOTER //
// ./src/components/sj-progress/index.js